export default __webpack_public_path__ + "static/media/web.1e8c1360.PNG";